import { render } from "./CreateModal.vue?vue&type=template&id=6c65e55a&scoped=true"
import script from "./CreateModal.vue?vue&type=script&lang=js"
export * from "./CreateModal.vue?vue&type=script&lang=js"

import "./CreateModal.vue?vue&type=style&index=0&id=6c65e55a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c65e55a"]])

export default __exports__